import styled from 'styled-components';

export const Sidebar = styled.aside`
    width: 350px;
`;
